export enum RequestExport {
  Request = 'EXPORT_SUBJECT_REQUEST',
  Success = 'EXPORT_SUBJECT_SUCCESS',
  Failed = 'EXPORT_SUBJECT_FAILED',
}

export enum fetchExports {
  Request = 'FETCH_EXPORTS_SUBJECT_REQUEST',
  Success = 'FETCH_EXPORTS_SUBJECT_SUCCESS',
  Failed = 'FETCH_EXPORTS_SUBJECT_FAILED',
}

export const GET_COMPANY_INIT_EXPORT_REQUEST = 'GET_COMPANY_INIT_EXPORT_REQUEST';
export const GET_COMPANY_INIT_EXPORT_SUCCESS = 'GET_COMPANY_INIT_EXPORT_SUCCESS';
export const GET_COMPANY_INIT_EXPORT_FAILED = 'GET_COMPANY_INIT_EXPORT_FAILED';
export const GET_COMPANY_EXPORT_STATUS_REQUEST = 'GET_COMPANY_EXPORT_STATUS_REQUEST';
export const GET_COMPANY_EXPORT_STATUS_SUCCESS = 'GET_COMPANY_EXPORT_STATUS_SUCCESS';
export const GET_COMPANY_EXPORT_STATUS_FAILED = 'GET_COMPANY_EXPORT_STATUS_FAILED';
